import { classNames } from '@/lib/utils'

export function StatusBadge({ value }: { value: string | null | undefined }) {
  const safe = (value ?? 'unknown').toLowerCase()

  return <span className={classNames('badge', safe)}>{value ?? '—'}</span>
}
